module.exports = __webpack_public_path__ + "static/media/wavemaker-350.09d3dc0f.png";